import { handleActions } from "redux-actions";
import { push } from "react-router-redux";
import { initialize as initializeForm } from "redux-form";
import Swal from "sweetalert2";
import { api } from "api";

const LOADER = "COMPLEJIDAD_PROYECTO_LOADER";
const LOADER_EDITAR = "COMPLEJIDAD_PROYECTO_LOADER_EDITAR";
const DATA = "COMPLEJIDAD_PROYECTO_DATA";
const SUBMIT = "COMPLEJIDAD_PROYECTO_SUBMIT";
const SELECT = "COMPLEJIDAD_PROYECTO_SELECT";

const ENDPOINT = "complejidad_proyecto";

export const constants = {
    SUBMIT,
};

// ------------------------------------
// Pure Actions
// ------------------------------------

export const setLoader = (loader) => ({
    type: LOADER,
    loader,
});

export const setData = (data) => ({
    type: DATA,
    data,
});

export const setLoaderEditar = (loaderEditar) => ({
    type: LOADER_EDITAR,
    loaderEditar,
});

export const setSelect = (select) => ({
    type: SELECT,
    select,
});

// ------------------------------------
// Actions
// ------------------------------------
export const onSubmit =
    (data = {}) =>
    (dispatch, getStore) => {
        dispatch(setLoaderEditar(true));
        api.post(`${ENDPOINT}`, data)
            .then(() => {
                Swal.fire({
                    title: "Éxito",
                    text: "Se ha guardado correctamente",
                    type: "success",
                    showConfirmButton: false,
                    timer: 500,
                });
                dispatch(push("/complejidad_proyectos"));
            })
            .catch((error) => {
                const textError = error && error.nombre
                ? "\nEste país ya existe"
                : "Ha ocurrido un error, inténtelo nuevamente."
                ;
                Swal.fire({
                    title: "Error",
                    text: textError,
                    type: "error",
                });
            })
            .finally(() => {
                dispatch(setLoaderEditar(false));
            });
    };

export const listar =
    (page = 1, params = {}) =>
    (dispatch) => {
        dispatch(setLoader(true));
        api.get(`${ENDPOINT}`, { page, ...params })
            .then((response) => {
                dispatch(setData(response));
            })
            .catch(() => {})
            .finally(() => {
                dispatch(setLoader(false));
            });
    };

export const obtenerComplejidadProyecto =
    (id = null) =>
    (dispatch) => {
        dispatch(setLoaderEditar(true));
        api.get(`${ENDPOINT}/${id}`)
            .then((response) => {
                dispatch(initializeForm("CrearEditarForm", response));
            })
            .catch(() => {})
            .finally(() => {
                dispatch(setLoaderEditar(false));
            });
    };

export const actualizarComplejidadProyecto =
    (data = {}, id = null) =>
    (dispatch) => {
        dispatch(setLoaderEditar(true));
        api.put(`${ENDPOINT}/${id}`, data)
            .then(() => {
                Swal.fire({
                    title: "Éxito",
                    text: "Se ha actualizado correctamente",
                    type: "success",
                    showConfirmButton: false,
                    timer: 500,
                });
                dispatch(push("/complejidad_proyectos"));
            })
            .catch((error) => {
                const textError = error && error.nombre
                ? "\nEste país ya existe"
                : "Ha ocurrido un error, inténtelo nuevamente."
                ;
                Swal.fire({
                    title: "Error",
                    text: textError,
                    type: "error",
                });
            })
            .finally(() => {
                dispatch(setLoaderEditar(false));
            });
    };

export const eliminar = (id) => (dispatch) => {
    dispatch(setLoader(true));
    api.eliminar(`${ENDPOINT}/${id}`)
        .then(() => {
            Swal.fire({
                title: "Éxito",
                text: "Se ha eliminado correctamente",
                type: "success",
            });
        })
        .catch(() => {})
        .finally(() => {
            dispatch(setLoader(false));
        });
};

export const obtenerSelectList = () => (dispatch) => {
    dispatch(setLoader(true));
    api.get(`${ENDPOINT}/filter_list`)
        .then((response) => {
            dispatch(setSelect(response));
        })
        .catch((error) => {
            dispatch(setSelect([]));
        })
        .finally(() => {
            dispatch(setLoader(false));
        });
};

export const actions = {
    onSubmit,
    eliminar,
    obtenerComplejidadProyecto,
    actualizarComplejidadProyecto,
    listar,
    obtenerSelectList,
};

export const reducers = {
    [LOADER]: (state, { loader }) => {
        return {
            ...state,
            loader,
        };
    },
    [LOADER_EDITAR]: (state, { loaderEditar }) => {
        return {
            ...state,
            loaderEditar,
        };
    },
    [DATA]: (state, { data }) => {
        return {
            ...state,
            data,
        };
    },
    [SELECT]: (state, { select }) => {
        return {
            ...state,
            select,
        };
    },
};

export const initialState = {
    loader: false,
    loaderEditar: false,
    data: {},
    select: [],
};

export default handleActions(reducers, initialState);
